"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.22",
    height: "9",
    viewBox: "0 0 11.22 9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,3.51H7.84L6,1.69A1,1,0,1,1,7.43.29l3.5,3.51a1,1,0,0,1,0,1.4L7.43,8.71A1,1,0,0,1,6,7.31L7.84,5.49H1a1,1,0,0,1,0-2Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;